import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Switch, Route, Redirect } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import { routes } from './config/routes';
import LoginForm from './LoginForm';
import NotFound from './pages/NotFound';
import ReactSecureStorage from 'react-secure-storage';
import { createTheme, ThemeProvider } from '@mui/material';
import { useLocation } from "react-router-dom";

//Material-UI 기본 테마 설정
const theme = createTheme({});
  
const allowedPublicRoutes = ["/distributorRequest", "/maintenance"];

const PrivateRoute = ({ component: Component, authenticated, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authenticated || allowedPublicRoutes.includes(props.location.pathname) ? (
        <Component {...props} />
      ) : (
        <Redirect
          //to={{ pathname: '/login', state: { from: props.location } }}
          to={`/login?redirect=${encodeURIComponent(props.location.pathname)}`}
          //to={`/login?redirect=${encodeURIComponent(ReactSecureStorage.getItem('redirect'))}`}
        />
      )
    }
  />
);

function App() {  
  useEffect(() => {
    const isMaintenance = false; // 배포중 true, 배포후에 false로 변경
  
    if (isMaintenance && window.location.pathname !== "/maintenance") {
      window.history.replaceState(null, "", "/maintenance"); // 뒤로가기 방지
      window.location.href = "/maintenance"; // 유지보수 페이지로 강제 이동
    }
  }, []);

  const [authenticated, setAuthenticated] = useState(
    ReactSecureStorage.getItem('authenticated') || false,
  );

  if (!(authenticated && allowedPublicRoutes.includes(window.location.pathname))) {
    if (window.location.pathname !== '/login') {
      if (window.location.pathname !== '/distributorRequest' && window.location.pathname !== '/maintenance') {
        ReactSecureStorage.setItem('redirect', window.location.pathname);
      }
    }
  }

  if (authenticated) {
    if (window.location.pathname === '/login') {
      if (ReactSecureStorage.getItem('redirect') != null && ReactSecureStorage.getItem('redirect') !== 'undefined' 
      && ReactSecureStorage.getItem('redirect') != 'null') {
      window.location.href = ReactSecureStorage.getItem('redirect');
      }
    }
  }

  const logout = () => {
    ReactSecureStorage.clear();
    setAuthenticated(false);
    window.location.href = '/login';
  };

  return (
    <ThemeProvider theme={theme}>
      {authenticated || allowedPublicRoutes.includes(window.location.pathname) ? <Header logout={logout} /> : <header />}
      {/* <Header logout={logout} />  */}
      <Container>
        <Switch>
          <Route
            path="/login"
            render={(props) => (
              <LoginForm setAuthenticated={setAuthenticated} {...props} />
            )}
          />
          {routes.map((route, index) => (
            <PrivateRoute
              key={index}
              path={route.path}
              component={route.component}
              authenticated={ReactSecureStorage.getItem('authenticated')}
            />
          ))}
          <Redirect exact from="/" to="/home" />
          <Route path="*" component={NotFound} />
        </Switch>
      </Container>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
